////FORMAT////
function formatStartEndDate(date) {
  return date.split('T')[0].replaceAll('-', '/');
}

function formatBillPeriod(date) {
  const newDate = new Date(date);

  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  };

  return new Intl.DateTimeFormat('en-GB', options).format(newDate);
}

function formatCost(cost) {
  let newCost = cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  newCost = `$${newCost}`;

  return newCost;
}

function formatCommas(value, units) {
  let newValue;

  if (value !== undefined && value !== null) {
    newValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ` ${units}`;
  } else {
    newValue = 'No Data';
  }

  return newValue;
}

function formatFromDateMs(dateInMilliseconds) {
  let tempTime = new Date(dateInMilliseconds);
  tempTime.setHours(0, 0, 0, 0);

  return tempTime.getTime();
}

function formatToDateMs(dateInMilliseconds) {
  let tempTime = new Date(dateInMilliseconds);
  tempTime.setHours(23, 59, 59, 0);

  return tempTime.getTime();
}

function formatGraphTitle(graphName) {
  const spacedStr = graphName.replace(/([a-z])([A-Z])/g, '$1 $2');

  const finalStr = spacedStr.charAt(0).toUpperCase() + spacedStr.slice(1);

  return finalStr;
}

export { formatStartEndDate, formatBillPeriod, formatCommas, formatCost, formatGraphTitle };
